<script>
    export let curriculumMbl;
    const openDiv = [];
    let btn;
</script>

<section>
    <div style="width: 91.111vw;margin:7vw auto;padding:0 1vw;">
        <div
            style="border-radius:3vw;box-shadow: 0vw 0.265vw 2.912vw rgba(0, 32, 75, 0.2);"
        >
            {#each curriculumMbl as data, i}
                <div class="content-holder">
                    <div style="display: inline-flex;padding:3vw;align-items: center;width: 89vw;">
                        <div
                            class="img-wrraper-logo"
                            style="width: 10vw;
                            margin: 0vw 8vw 0vw 2vw;"
                        >
                            <img src={data.img} alt="" width="100%"/>
                        </div>
                        <div>
                            <h1
                                class="section1list"
                                style="font-size: 3.889vw;margin-top:2vw;width: 44.355vw;font-weight: 300;color: #00204B;"
                            >
                                {data.title}
                            </h1>
                        </div>
                        <div
                            style=" width: 22vw;
                            text-align: end;    padding-right: 4vw;"
                        >
                            <button
                                class="view-all-btn "
                                on:click={() => {
                                    if (openDiv[i].style.display === 'none') {
                                        openDiv[i].style.display = 'block';
                                        btn.style.transform = 'rotate(180deg)';
                                    } else {
                                        openDiv[i].style.display = 'none';
                                        btn.style.transform = 'rotate(0deg)';
                                    }
                                }}
                            >
                                <img
                                    bind:this={btn}
                                    src="/images/Hero_section/drop_down.svg"
                                    alt=""
                                    width="100%"
                                />
                            </button>
                            
                        </div>
                    </div>

                    <div
                        class="openDiv"
                        style="width: 75vw;margin: auto; padding-bottom: 1vw;"
                        bind:this={openDiv[i]}
                    >
                        <p style="font-size:3.056vw;">
                            {data.text}
                        </p>
                    </div>
                </div>
            {/each}
        </div>
    </div>
</section>

<style>
    .content-holder:nth-child(odd) {
        background-color: rgba(226, 242, 255, 1);
    }
    .content-holder:nth-child(1) {
        border-top-left-radius: 3vw;
        border-top-right-radius: 3vw;
    }
    .view-all-btn {
        border: none;
        background-color: transparent;
        width: 3.2vw;
    }
    .openDiv {
        display: none;
    }
</style>
